import { Component, OnDestroy, Inject, OnInit } from '@angular/core';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
} from '@richardlt/ng2-semantic-ui';
import { DOCUMENT } from '@angular/common';
import { EwalletService } from 'src/modules/features/admin/services/ewallet';
interface IConfirmModalContext {
  terms: any;
}
@Component({
  selector: 'app-tandc-modal',
  templateUrl: './tandc-modal.component.html',
  styleUrls: ['./tandc-modal.component.scss'],
})
export class TAndCModalComponent implements OnInit, OnDestroy {
  terms;
  pending: boolean = false;
  error: any;
  success: any;
  constructor(
    @Inject(DOCUMENT) private document,
    public modal: SuiModal<IConfirmModalContext, void, void>,
    private walletService: EwalletService
  ) {
    this.getTerms();
  }
  ngOnInit() {
    this.document.body.classList.remove('panel');
  }
  getTerms() {
    this.pending = true;
    this.error = null;
    this.walletService.getTermsAndCondition().subscribe(
      (res: any) => {
        this.terms = res;
        this.pending = false;
      },
      (error) => {
        this.pending = false;
        this.error = error.error;
      }
    );
  }
  ngOnDestroy(): void {
    this.document.body.classList.add('panel');
  }
}
export class TAndCModal extends ComponentModalConfig<
  IConfirmModalContext,
  void,
  void
> {
  constructor(terms, size: ModalSize = ModalSize.Large) {
    super(TAndCModalComponent, { terms });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
